import { render, staticRenderFns } from "./ReportKPIPage.vue?vue&type=template&id=76ff780e&scoped=true&"
import script from "./ReportKPIPage.vue?vue&type=script&lang=js&"
export * from "./ReportKPIPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ff780e",
  null
  
)

export default component.exports